export class UpdateAccountPreferenceRequest {
    preference: string = '';
    value: string = '';
}